import { useMemo } from "react";
import { computeFunnel } from "@/lib/funnelUtils";

/**
 * useFunnelData — memoizes the funnel computation so the React component
 * stays a thin presentational layer.
 */
export default function useFunnelData(contacts, quotes) {
  return useMemo(() => computeFunnel(contacts, quotes), [contacts, quotes]);
}
